import AccessibleSelect from '../native-accessible-select/native-accessible-select';
import Vue from 'vue';
export default {
	// When the bound element is inserted into the DOM...
	inserted: function(el) {
		// Focus the element
		/* eslint-disable no-new*/
		Vue.nextTick(() => {
			new AccessibleSelect({ element: el }); // NOSONAR
		});
		/* eslint-enable no-new*/
	}
};
